// @flow

import Config from '@insolus/config';
import globalConfig from '../global';

export default () => {
    Config.init(globalConfig);
};
